export const createSubscriptionItem = `
    mutation createSubscriptionItem($input: CreateSubscriptionItemInput!) {
        createSubscriptionItem(input:$input) {
          id
          price
          quantity
          subscription
          created
    }
}`;

export const updateSubscriptionItem = `
    mutation updateSubscriptionItem($input: UpdateSubscriptionItemInput!) {
        updateSubscriptionItem(input:$input){
          id
          price
          quantity
          subscription
          created
        }
}`;

export const deleteSubscriptionItem = `
    mutation deleteSubscriptionItem($input: DeleteSubscriptionItemInput!) {
        deleteSubscriptionItem(input:$input)
}`;
